import { useCallback, useState } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { useJWPlayerEvent } from './useJWPlayerEvent';

export const useDuration = () => {
  const player = usePlayer();
  const [duration, setDuration] = useState(
    player.getJWPlayer()?.getDuration() ?? 0
  );

  const handleTime = useCallback((param: jwplayer.TimeParam) => {
    setDuration(param.duration);
  }, []);

  useJWPlayerEvent('time', handleTime);

  return { duration };
};
